import {
  Field,
  Item,
  RichText,
  Text,
  getFieldValue,
  withDatasourceCheck,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import type { ComponentProps } from 'lib/component-props';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';
import type { RecordOfFields } from 'models/fields';
import Location, { type LocationProps } from './Location';

import styles from './LocationsListing.module.scss';

type LocationsListingProps = ComponentProps & {
  fields: {
    heading: Field<string>;
    headingLevel: Item | null;
    headingTextStyle: Item | null;
    description: Field<string>;
    displayMode: Item | null;
    locations: LocationProps[];
  };
};

const cx = classNames.bind(styles);

const LocationsListing = (props: LocationsListingProps): JSX.Element => {
  const { fields } = props;
  const headingLevelItemField = fields.headingLevel?.fields as RecordOfFields;
  const headingLevelValue = getFieldValue<string>(headingLevelItemField, 'Value') || 'h1';

  const { sitecoreContext } = useSitecoreContext();

  const headingTextStyleItemField = fields.headingTextStyle?.fields as RecordOfFields;
  const headingTextStyleValue = getFieldValue<string>(headingTextStyleItemField, 'Value') || 'font-style-xl';

  const displayModeItemField = fields.displayMode?.fields as RecordOfFields;
  const displayModeValue = getFieldValue<string>(displayModeItemField, 'Value') || 'singleColumn';

  return (
    <>
      <Text
        className={cx({ [headingTextStyleValue]: true })}
        field={fields.heading}
        tag={headingLevelValue}
        editable={true}
        encode={sitecoreContext.pageEditing}
      />
      <RichText className={cx('body')} field={fields.description} tag="div" />
      <div className={cx({ ['locations']: true, [displayModeValue]: true })}>
        {fields.locations?.map((loc, i) => (
          <Location key={i + loc.id} id={i.toString() + loc.id} fields={loc.fields} />
        ))}
      </div>
    </>
  );
};

export default compose<LocationsListingProps>(withDatasourceCheck(), withStyles())(LocationsListing);
